<template>
  <div class="row bar">
    <div class="col-9 col-md-12 col-lg-9"><img/>
    </div>
    <div class="col-3 col-md-12 col-lg-3">
      <div class="row shared-bar">
        <div class="col-12 col-md-4 col-lg-12">Shared</div>
        <div class="col-6 col-md-2 col-lg-6"><i><icon name="facebook-f"></icon></i></div>
        <div class="col-6 col-md-2 col-lg-6"><i><icon name="twitter"></icon></i></div>
        <div class="col-6 col-md-2 col-lg-6"><i><icon name="linkedin"></icon></i></div>
        <div class="col-6 col-md-2 col-lg-6"><i><icon name="google-plus"></icon></i></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'altmetric-stats-bar'
  }
</script>

<style lang="scss" scoped>
  div.bar {
    font-size: 12px;
    font-style: italic;
    color: #ccc;
  }
  .shared-bar {
    div {
      padding-right: 5px;
    }
    i {
      margin-left: -5px;
      margin-top: 5px;
      padding: 5px;
      display: block;
      color: $white;
      background-color: $primary-color;
      height: 24px;
      width: 24px;
    }
  }
  img {
    width: 100%;
    min-height: 120px;
    background-color: #eee;
    border: 1px solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// AltmetricStatsBarComponent.vue?5d0858c8